import React, { useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { LangCtx, PayLoadCtx } from "../../lib/context";
import ProfileMenu from "./ProfileMenu";
import "./styles.css";

export function BottomNavigation(props) {
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const location = useLocation();
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);
    const role = payload?.consultRole;

    const handleOpenProfileMenu = () => {
        setProfileMenuOpen(true);
    };

    const handleCloseProfileMenu = () => {
        setProfileMenuOpen(false);
    };

    const loadNav = () => {
        switch (role) {
            case "doctor":
                return (
                    <>
                        <Link
                            to="/doctor-appointments"
                            className={location.pathname === "/doctor-appointments" ? "nav-item active" : "nav-item"}
                        >
                            <img src="/images/icons/appointments-outline.png" className="nav-icon" alt="Appointments" />
                            <span className="nav-label">{l.apptmnts || "Appointments"}</span>
                        </Link>
                        <Link to="/doctor-schedules" className={location.pathname === "/doctor-schedules" ? "nav-item active" : "nav-item"}>
                            <img src="/images/icons/create-schedule-outline.png" className="nav-icon" alt="Schedules" />
                            <span className="nav-label">{l.create_sched || "Schedules"}</span>
                        </Link>
                        <Link to="/doctor-invites" className={location.pathname === "/doctor-invites" ? "nav-item active" : "nav-item"}>
                            <img src="/images/icons/invite-outline.png" className="nav-icon" alt="Invites" />
                            <span className="nav-label">{l.invite || "Invites"}</span>
                        </Link>
                        <div className="nav-item" onClick={handleOpenProfileMenu}>
                            <img src="/images/icons/black-more-icon.png" className="nav-icon" alt="More" />
                            <span className="nav-label">{l.more || "More"}</span>
                        </div>
                    </>
                );
            case "clinic":
                return (
                    <>
                        <Link to="/clinic-dashboard" className={location.pathname === "/clinic-dashboard" ? "nav-item active" : "nav-item"}>
                            <img src="/images/icons/dashboard.png" className="nav-icon" alt="Dashboard" />
                            <span className="nav-label">{l.dashboard || "Dashboard"}</span>
                        </Link>
                        <Link to="/appointments" className={location.pathname === "/appointments" ? "nav-item active" : "nav-item"}>
                            <img src="/images/icons/appointments-outline.png" className="nav-icon" alt="Appointments" />
                            <span className="nav-label">{l.apptmnts || "Appointments"}</span>
                        </Link>
                        <Link to="/clinic-users" className={location.pathname === "/clinic-users" ? "nav-item active" : "nav-item"}>
                            <img src="/images/icons/patients-list.png" className="nav-icon" alt="Users" />
                            <span className="nav-label">{l.users || "Users"}</span>
                        </Link>
                        <div className="nav-item" onClick={handleOpenProfileMenu}>
                            <img src="/images/icons/black-more-icon.png" className="nav-icon" alt="More" />
                            <span className="nav-label">{l.more || "More"}</span>
                        </div>
                    </>
                );
            case "Admin":
                return (
                    <>
                        <Link to="/dashboard" className={location.pathname === "/dashboard" ? "nav-item active" : "nav-item"}>
                            <img src="/images/icons/dashboard.png" className="nav-icon" alt="Dashboard" />
                            <span className="nav-label">{l.dashboard || "Dashboard"}</span>
                        </Link>
                        <Link
                            to="/admin-createusers"
                            className={location.pathname === "/admin-createusers" ? "nav-item active" : "nav-item"}
                        >
                            <img src="/images/icons/create-patient.png" className="nav-icon" alt="Create" />
                            <span className="nav-label">{l.create_user || "Create"}</span>
                        </Link>
                        <Link to="/admin-users" className={location.pathname === "/admin-users" ? "nav-item active" : "nav-item"}>
                            <img src="/images/icons/patients-list.png" className="nav-icon" alt="Users" />
                            <span className="nav-label">{l.users || "Users"}</span>
                        </Link>
                        <div className="nav-item" onClick={handleOpenProfileMenu}>
                            <img src="/images/icons/black-more-icon.png" className="nav-icon" alt="More" />
                            <span className="nav-label">{l.more || "More"}</span>
                        </div>
                    </>
                );
            default:
                return (
                    <>
                        <Link
                            to="/patient-dashboard"
                            className={location.pathname === "/patient-dashboard" ? "nav-item active" : "nav-item"}
                        >
                            <img src="/images/icons/appointments-outline.png" className="nav-icon" alt="Appointments" />
                            <span className="nav-label">{l.apptmnts || "Appointments"}</span>
                        </Link>
                        <Link to="/doctor-booking" className={location.pathname === "/doctor-booking" ? "nav-item active" : "nav-item"}>
                            <img src="/images/icons/create-schedule-outline.png" className="nav-icon" alt="Book" />
                            <span className="nav-label">{l.book_apptmnt || "Book"}</span>
                        </Link>
                        <Link to="/patient-uploads" className={location.pathname === "/patient-uploads" ? "nav-item active" : "nav-item"}>
                            <img src="/images/icons/uploads-outline.png" className="nav-icon" alt="Uploads" />
                            <span className="nav-label">{l.my_uploads || "Uploads"}</span>
                        </Link>
                        <div className="nav-item" onClick={handleOpenProfileMenu}>
                            <img src="/images/icons/black-more-icon.png" className="nav-icon" alt="More" />
                            <span className="nav-label">{l.more || "More"}</span>
                        </div>
                    </>
                );
        }
    };

    return (
        <>
            <nav className="bottom-navigation">{loadNav()}</nav>
            <ProfileMenu isOpen={profileMenuOpen} onClose={handleCloseProfileMenu} handleLogout={props.handleLogout} />
        </>
    );
}
